import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import Text from '@ui/text/text/text';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';

/**
 * Indicator for audience lists that are gating registration (BDEV-5154): the list is attached
 * to the project while the audience list gate is on. `chip` matches the member-count chip on
 * the grid card; `icon` is the compact form for list-view rows.
 */
const RestrictsAccessBadge = ({ variant }: { variant: 'chip' | 'icon' }) => {
  return (
    <TooltipPortal
      childrenWrapperClass="flex"
      keepOpenOnContentHover={false}
      styles={{ padding: '8px 4px' }}
      verticalOffset={-4}
      tooltipContent={
        <Text design="GlobalIcoText1" className="P2" maxWidth="290px">
          This list restricts who can register.
        </Text>
      }
    >
      {variant === 'chip' ? (
        <Container className="flex radius-8 padding-v-8 padding-h-10 ai-center gap-6" design="GlobalCont2">
          <Icon name={ICONS.LOCK} size={12} color="var(--global-ico-text-2)" />
          <Text className="C1" design="GlobalIcoText2">
            Gated
          </Text>
        </Container>
      ) : (
        <Icon name={ICONS.LOCK} size={12} color="var(--global-ico-text-2)" />
      )}
    </TooltipPortal>
  );
};

export default RestrictsAccessBadge;
